var _g, _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLioActiveBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2436_15806)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.2959,
    cy: 40,
    r: 40,
    fill: "#1F2B3D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_2436_15806)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -7.20158,
    cy: 18.2719,
    r: 56.633,
    fill: "#00D0DB"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter1_f_2436_15806)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.15,
    cy: 92.9658,
    r: 56.633,
    fill: "#C4AAEB"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter2_f_2436_15806)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.607,
    cy: -2.87908,
    r: 46.176,
    fill: "#C4AAEB"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5956 59.8498C43.6699 59.7839 43.7444 59.7184 43.8193 59.6533C43.8223 59.6507 43.8254 59.648 43.8284 59.6453C47.6793 56.3026 52.3918 54.1699 57.3956 53.4977C57.689 53.4583 57.9834 53.4239 58.2787 53.3945L58.5493 53.3677C58.6548 53.3572 58.7565 53.3348 58.8532 53.3019C59.4054 53.1139 59.7959 52.5826 59.7959 51.9655V30.427C59.7959 29.649 59.1779 29.0183 58.4157 29.0183H52.3468L51.1879 28.4942C47.6319 26.8862 44.5916 24.2884 42.4153 20.9983L40.4319 18L38.4486 20.9983C36.2723 24.2884 33.232 26.8862 29.676 28.4942L28.5171 29.0183H22.6761C21.9139 29.0183 21.2959 29.649 21.2959 30.427V51.9655C21.2959 52.5826 21.6864 53.1139 22.2386 53.3019C22.3353 53.3348 22.437 53.3572 22.5425 53.3677L22.8131 53.3945C23.1084 53.4239 23.4028 53.4583 23.6962 53.4977C28.7 54.1699 33.4125 56.3026 37.2634 59.6453L37.2714 59.6523C37.3466 59.7177 37.4216 59.7835 37.4961 59.8498L39.5256 61.6536C39.6074 61.7263 39.6961 61.7879 39.7895 61.8381C40.0226 61.9632 40.2854 62.0172 40.5459 61.9952C40.8064 62.0172 41.0692 61.9632 41.3023 61.8381C41.3958 61.7879 41.4844 61.7263 41.5662 61.6536L43.5956 59.8498ZM44.8005 55.3787C44.3732 55.6679 43.9529 55.969 43.5402 56.2818C43.0282 56.6697 42.5279 57.0756 42.04 57.4991V40.4229L42.4153 39.8556C44.5916 36.5655 47.6319 33.9677 51.1879 32.3597L52.3465 31.8358H57.0354V50.7042C52.6498 51.2934 48.4668 52.8976 44.8005 55.3787ZM48.7585 30.427C45.4495 28.6727 42.5934 26.1362 40.4319 23.0241C38.2705 26.1362 35.4144 28.6727 32.1054 30.427C35.4144 32.1812 38.2705 34.7177 40.4319 37.8298C42.5934 34.7177 45.4495 32.1812 48.7585 30.427ZM39.0518 40.7674L38.4486 39.8556C36.2723 36.5655 33.232 33.9677 29.676 32.3597L28.5174 31.8358H24.0564V50.7042C24.1051 50.7108 24.1537 50.7174 24.2024 50.7242C28.5348 51.3291 32.6657 52.9251 36.2913 55.3787C37.2485 56.0265 38.1705 56.7341 39.0518 57.4991V40.7674Z",
    fill: "url(#paint0_linear_2436_15806)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8003 55.3788C44.373 55.6679 43.9527 55.969 43.5399 56.2818C43.028 56.6697 42.5276 57.0756 42.0398 57.4991V40.4229L42.415 39.8557C44.5914 36.5656 47.6317 33.9677 51.1877 32.3597L52.3463 31.8358H57.0352V50.7043C52.6496 51.2934 48.4666 52.8976 44.8003 55.3788ZM48.7582 30.427C45.4492 28.6728 42.5931 26.1363 40.4317 23.0242C38.2702 26.1363 35.4141 28.6728 32.1052 30.427C35.4141 32.1813 38.2702 34.7177 40.4317 37.8298C42.5931 34.7177 45.4492 32.1813 48.7582 30.427ZM39.0515 40.7675L38.4484 39.8557C36.272 36.5656 33.2317 33.9677 29.6757 32.3597L28.5171 31.8358H24.0562V50.7043C24.1048 50.7108 24.1535 50.7175 24.2021 50.7243C28.5345 51.3291 32.6654 52.9252 36.291 55.3788C37.2483 56.0266 38.1703 56.7342 39.0515 57.4991V40.7675Z",
    fill: "#0C1119"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.2959,
    width: 35.6555,
    height: 15.4006,
    rx: 7.70028,
    fill: "#5265FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.2959 11.2727V4H53.134V6.68466H53.205C53.2665 6.58996 53.3518 6.46922 53.4607 6.32244C53.5719 6.1733 53.7306 6.04072 53.9365 5.92472C54.1449 5.80634 54.4266 5.74716 54.7817 5.74716C55.241 5.74716 55.6458 5.86198 55.9962 6.09162C56.3466 6.32126 56.62 6.64678 56.8165 7.06818C57.013 7.48958 57.1112 7.98674 57.1112 8.55966C57.1112 9.13731 57.013 9.63802 56.8165 10.0618C56.62 10.4832 56.3477 10.8099 55.9997 11.0419C55.6517 11.2715 55.2504 11.3864 54.7959 11.3864C54.4455 11.3864 54.165 11.3284 53.9543 11.2124C53.7436 11.094 53.5814 10.9602 53.4678 10.8111C53.3541 10.6596 53.2665 10.5341 53.205 10.4347H53.1056V11.2727H52.2959ZM53.1198 8.54545C53.1198 8.95739 53.1801 9.32079 53.3009 9.63565C53.4216 9.94815 53.598 10.1932 53.83 10.3707C54.062 10.5459 54.3461 10.6335 54.6823 10.6335C55.0326 10.6335 55.325 10.5412 55.5594 10.3565C55.7961 10.1695 55.9737 9.91856 56.0921 9.60369C56.2128 9.28646 56.2732 8.93371 56.2732 8.54545C56.2732 8.16193 56.214 7.81629 56.0956 7.50852C55.9796 7.19839 55.8032 6.95336 55.5665 6.77344C55.3321 6.59115 55.0374 6.5 54.6823 6.5C54.3414 6.5 54.0549 6.58641 53.8229 6.75923C53.5909 6.92969 53.4157 7.1688 53.2973 7.47656C53.1789 7.78196 53.1198 8.13826 53.1198 8.54545Z",
    fill: "#F2F4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6801 11.3864C60.1546 11.3864 59.7012 11.2704 59.32 11.0384C58.9413 10.804 58.6489 10.4773 58.4429 10.0582C58.2393 9.63684 58.1375 9.14678 58.1375 8.58807C58.1375 8.02936 58.2393 7.53693 58.4429 7.1108C58.6489 6.68229 58.9353 6.34848 59.3023 6.10938C59.6716 5.8679 60.1025 5.74716 60.5949 5.74716C60.879 5.74716 61.1595 5.79451 61.4365 5.8892C61.7135 5.9839 61.9656 6.13778 62.1929 6.35085C62.4202 6.56155 62.6013 6.84091 62.7362 7.18892C62.8712 7.53693 62.9387 7.96544 62.9387 8.47443V8.82955H58.7341V8.10511H62.0864C62.0864 7.79735 62.0248 7.52273 61.9017 7.28125C61.781 7.03977 61.6082 6.8492 61.3833 6.70952C61.1607 6.56984 60.8979 6.5 60.5949 6.5C60.2611 6.5 59.9723 6.58286 59.7284 6.74858C59.4869 6.91193 59.3011 7.125 59.1709 7.38778C59.0407 7.65057 58.9756 7.93229 58.9756 8.23295V8.71591C58.9756 9.12784 59.0466 9.47704 59.1887 9.76349C59.3331 10.0476 59.5331 10.2642 59.7888 10.4134C60.0445 10.5601 60.3416 10.6335 60.6801 10.6335C60.9003 10.6335 61.0992 10.6027 61.2767 10.5412C61.4566 10.4773 61.6117 10.3826 61.7419 10.2571C61.8721 10.1293 61.9727 9.97064 62.0438 9.78125L62.8534 10.0085C62.7682 10.2831 62.625 10.5246 62.4237 10.733C62.2225 10.9389 61.9739 11.0999 61.678 11.2159C61.3821 11.3295 61.0494 11.3864 60.6801 11.3864Z",
    fill: "#F2F4F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5857 5.81818V6.52841H63.759V5.81818H66.5857ZM64.5828 4.51136H65.4209V9.71023C65.4209 9.94697 65.4552 10.1245 65.5239 10.2429C65.5949 10.3589 65.6849 10.437 65.7938 10.4773C65.905 10.5152 66.0222 10.5341 66.1453 10.5341C66.2377 10.5341 66.3134 10.5294 66.3726 10.5199C66.4318 10.508 66.4791 10.4986 66.5146 10.4915L66.6851 11.2443C66.6283 11.2656 66.549 11.2869 66.4472 11.3082C66.3454 11.3319 66.2164 11.3438 66.0601 11.3438C65.8234 11.3438 65.5914 11.2929 65.3641 11.1911C65.1392 11.0893 64.9521 10.9342 64.803 10.7259C64.6562 10.5175 64.5828 10.2547 64.5828 9.9375V4.51136Z",
    fill: "#F2F4F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4514 11.4006C69.1058 11.4006 68.7921 11.3355 68.5104 11.2053C68.2287 11.0727 68.0049 10.8821 67.8392 10.6335C67.6735 10.3826 67.5906 10.0795 67.5906 9.72443C67.5906 9.41193 67.6522 9.15862 67.7753 8.96449C67.8984 8.76799 68.0629 8.61411 68.2689 8.50284C68.4749 8.39157 68.7021 8.30871 68.9507 8.25426C69.2017 8.19744 69.4538 8.15246 69.7071 8.11932C70.0386 8.0767 70.3073 8.04474 70.5132 8.02344C70.7216 7.99976 70.8731 7.9607 70.9678 7.90625C71.0648 7.8518 71.1134 7.7571 71.1134 7.62216V7.59375C71.1134 7.24337 71.0175 6.97112 70.8257 6.77699C70.6363 6.58286 70.3487 6.4858 69.9628 6.4858C69.5627 6.4858 69.249 6.57339 69.0218 6.74858C68.7945 6.92377 68.6347 7.1108 68.5423 7.30966L67.7469 7.02557C67.8889 6.69413 68.0783 6.43608 68.3151 6.25142C68.5542 6.06439 68.8146 5.93419 69.0963 5.8608C69.3804 5.78504 69.6598 5.74716 69.9344 5.74716C70.1096 5.74716 70.3108 5.76847 70.5381 5.81108C70.7677 5.85133 70.9891 5.93537 71.2021 6.06321C71.4176 6.19105 71.5963 6.384 71.7384 6.64205C71.8804 6.90009 71.9514 7.24574 71.9514 7.67898V11.2727H71.1134V10.5341H71.0708C71.0139 10.6525 70.9192 10.7791 70.7867 10.9141C70.6541 11.049 70.4777 11.1638 70.2575 11.2585C70.0374 11.3532 69.7687 11.4006 69.4514 11.4006ZM69.5793 10.6477C69.9107 10.6477 70.1901 10.5826 70.4173 10.4524C70.647 10.3222 70.8198 10.1541 70.9358 9.94815C71.0542 9.74219 71.1134 9.52557 71.1134 9.2983V8.53125C71.0779 8.57386 70.9997 8.61293 70.879 8.64844C70.7606 8.68158 70.6233 8.71117 70.4671 8.73722C70.3132 8.76089 70.1628 8.7822 70.0161 8.80114C69.8717 8.81771 69.7545 8.83191 69.6645 8.84375C69.4467 8.87216 69.2431 8.91832 69.0537 8.98224C68.8667 9.0438 68.7152 9.13731 68.5992 9.26278C68.4855 9.38589 68.4287 9.55398 68.4287 9.76705C68.4287 10.0582 68.5364 10.2784 68.7519 10.4276C68.9697 10.5743 69.2455 10.6477 69.5793 10.6477Z",
    fill: "#F2F4F7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2436_15806",
    x: -95.8346,
    y: -70.3611,
    width: 177.266,
    height: 177.266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_2436_15806"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2436_15806",
    x: -12.483,
    y: 4.33276,
    width: 177.266,
    height: 177.266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_2436_15806"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2436_15806",
    x: -1.56897,
    y: -81.0551,
    width: 156.352,
    height: 156.352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_2436_15806"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2436_15806",
    x1: 12.7614,
    y1: 36.9655,
    x2: 67.8562,
    y2: 36.9655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5265FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#764CB6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2436_15806"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.44043,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLioActiveBadge);
export default __webpack_public_path__ + "static/media/lio_active_badge.325f9827810a9614a84b73daf8ed1f16.svg";
export { ForwardRef as ReactComponent };